const toast = {
  error: {
    DEFAULT: "An error occurred",
    server: "Internal server error",
  },
};
export default toast;
